import React from "react";
import {
  FaAddressCard,
  FaHome,
  FaPalette,
  FaSyncAlt,
} from "react-icons/fa";

import { getCompletionPercent } from "../utils/parametresUtils";

export default function SettingsHero({
  loading,
  settings,
  activeTab,
  onChangeTab,
  onRefresh,
}) {
  const hasClubName = Boolean(settings?.nom_club);

  return (
    <section className="relative overflow-hidden rounded-[2rem] border border-slate-200 bg-slate-950 p-6 text-white shadow-xl shadow-slate-300/40 dark:border-slate-800 dark:shadow-none lg:p-8">
      <div className="absolute -right-24 -top-24 h-72 w-72 rounded-full bg-orange-500/30 blur-3xl" />
      <div className="absolute -bottom-28 left-1/3 h-72 w-72 rounded-full bg-blue-500/20 blur-3xl" />

      <div className="relative flex flex-col gap-6 xl:flex-row xl:items-end xl:justify-between">
        <div className="max-w-3xl">
          <p className="text-sm font-bold uppercase tracking-[0.24em] text-orange-200">
            Paramètres
          </p>

          <h1 className="mt-4 text-3xl font-bold tracking-tight sm:text-4xl">
            Paramètres du club
          </h1>

          <p className="mt-4 max-w-2xl text-sm leading-7 text-slate-300 sm:text-base">
            Centralisez l’identité du club, ses coordonnées, ses réseaux
            sociaux, le logo et les contenus de la page d’accueil du site.
          </p>
        </div>

        <div className="grid gap-3 sm:grid-cols-3 xl:min-w-[520px]">
          <div className="rounded-3xl border border-white/10 bg-white/10 p-4 backdrop-blur">
            <p className="text-xs uppercase tracking-[0.18em] text-slate-300">
              Club
            </p>
            <p className="mt-2 truncate text-2xl font-bold">
              {loading ? "..." : hasClubName ? settings.nom_club : "Non renseigné"}
            </p>
          </div>

          <div className="rounded-3xl border border-white/10 bg-white/10 p-4 backdrop-blur">
            <p className="text-xs uppercase tracking-[0.18em] text-slate-300">
              Couleur
            </p>
            <div className="mt-3 flex items-center gap-3">
              <span
                className="h-8 w-8 rounded-xl border border-white/20"
                style={{ backgroundColor: settings.primary_color || "#000000" }}
              />
              <span className="font-bold">
                {settings.primary_color || "#000000"}
              </span>
            </div>
          </div>

          <div className="rounded-3xl border border-white/10 bg-white/10 p-4 backdrop-blur">
            <p className="text-xs uppercase tracking-[0.18em] text-slate-300">
              État
            </p>
            <p className="mt-2 text-3xl font-bold">
              {loading ? "..." : `${getCompletionPercent(hasClubName ? 1 : 0, 1)}%`}
            </p>
          </div>
        </div>
      </div>

      <div className="relative mt-6 flex flex-wrap items-center gap-3">
        <button
          type="button"
          onClick={() => onChangeTab("identity")}
          className={`inline-flex items-center gap-2 rounded-2xl px-4 py-2.5 text-sm font-bold transition ${
            activeTab === "identity"
              ? "bg-white text-slate-950"
              : "border border-white/10 bg-white/10 text-white hover:bg-white/15"
          }`}
        >
          <FaAddressCard />
          Identité
        </button>

        <button
          type="button"
          onClick={() => onChangeTab("contact")}
          className={`inline-flex items-center gap-2 rounded-2xl px-4 py-2.5 text-sm font-bold transition ${
            activeTab === "contact"
              ? "bg-white text-slate-950"
              : "border border-white/10 bg-white/10 text-white hover:bg-white/15"
          }`}
        >
          <FaPalette />
          Coordonnées
        </button>

        <button
          type="button"
          onClick={() => onChangeTab("home")}
          className={`inline-flex items-center gap-2 rounded-2xl px-4 py-2.5 text-sm font-bold transition ${
            activeTab === "home"
              ? "bg-white text-slate-950"
              : "border border-white/10 bg-white/10 text-white hover:bg-white/15"
          }`}
        >
          <FaHome />
          Accueil
        </button>

        <button
          type="button"
          onClick={onRefresh}
          className="inline-flex items-center gap-2 rounded-2xl border border-white/10 bg-white/10 px-4 py-2.5 text-sm font-bold text-white transition hover:-translate-y-0.5 hover:bg-white/15"
        >
          <FaSyncAlt />
          Actualiser
        </button>
      </div>
    </section>
  );
}